// removed by extract-text-webpack-plugin
module.exports = {"social":"_33fw-YGpTRxHQExYr5xGBm","socialIcon":"_2oRSHXeHCs5698W0whnyST","socialWrapper":"_3i15h_If7Te_CNIZAgLskU","newSocial":"_2lYvLVQIoRoisV7wCXh8yA","socialWrap":"_1k-iZlXYGK6QB_-AZpPbty","socialTitle":"_2lZzzFYdA9TTmFNH00PcIy","pointerOnArea":"_30RY88J7NZcsbGUacHgsRO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAuthentication/SocialNetworkAuthentication/SocialNetworkAuthentication.scss
// module id = 1795
// module chunks = 0